var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0396 10.3197C20.9545 10.114 20.8103 9.93825 20.6252 9.81459C20.4401 9.69093 20.2225 9.62495 19.9999 9.625H16.6249V2.5C16.6249 2.00272 16.4274 1.52581 16.0758 1.17417C15.7241 0.822544 15.2472 0.625 14.7499 0.625H7.24995C6.75267 0.625 6.27575 0.822544 5.92412 1.17417C5.57249 1.52581 5.37495 2.00272 5.37495 2.5V9.625H1.99995C1.7774 9.62501 1.55985 9.69103 1.37482 9.81471C1.1898 9.93838 1.04561 10.1142 0.960506 10.3198C0.875401 10.5254 0.8532 10.7517 0.896711 10.9699C0.940223 11.1882 1.04749 11.3887 1.20495 11.5459L10.2049 20.5459C10.3095 20.6508 10.4337 20.734 10.5704 20.7908C10.7071 20.8476 10.8538 20.8768 11.0018 20.8768C11.1499 20.8768 11.2965 20.8476 11.4332 20.7908C11.57 20.734 11.6942 20.6508 11.7987 20.5459L20.7987 11.5459C20.9556 11.3883 21.0622 11.1876 21.1051 10.9693C21.148 10.7511 21.1252 10.525 21.0396 10.3197ZM10.9999 18.1562L4.7187 11.875H6.49995C6.79832 11.875 7.08446 11.7565 7.29544 11.5455C7.50642 11.3345 7.62495 11.0484 7.62495 10.75V2.875H14.3749V10.75C14.3749 11.0484 14.4935 11.3345 14.7045 11.5455C14.9154 11.7565 15.2016 11.875 15.4999 11.875H17.2812L10.9999 18.1562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRevenue);
export default __webpack_public_path__ + "static/media/arrow-down-revenue.32810aa21aeedfa738f7c24062f9d826.svg";
export { ForwardRef as ReactComponent };